/*
 * SPDX-FileCopyrightText: 2023 SAP Spartacus team <spartacus-team@sap.com>
 *
 * SPDX-License-Identifier: Apache-2.0
 */

import { GenCartEntryEffects } from './cart-entry.effect';
import { CartVoucherEffects } from './cart-voucher.effect';
import { CartEffects } from './cart.effect';
import { GenMultiCartEffects } from './multi-cart.effect';

export const genEffects: any[] = [
  GenCartEntryEffects,
  CartVoucherEffects,
  CartEffects,
  GenMultiCartEffects,
];

export * from './cart-entry.effect';
export * from './cart-voucher.effect';
export * from './cart.effect';
export * from './multi-cart.effect';
